export default __webpack_public_path__ + "assets/favicon.be80b07cbe589710754d1139f40593da.svg";